export default function Card({
	bg,
	dim = false,
	children,
}: {
	bg: string;
	dim?: boolean;
	children: React.ReactNode;
}) {
	return (
		<div className="relative size-full min-h-screen">
			<img
				src={bg}
				className={
					"absolute inset-0 size-full object-cover saturate-120" +
					(dim ? " brightness-70" : "")
				}
			/>
			<div className="relative size-full min-h-screen">{children}</div>
		</div>
	);
}
